import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';

var GoogleDriveLogo = function GoogleDriveLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5038_1153)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1.81443 18.8547L2.87285 20.7303C3.09278 21.1252 3.40893 21.4354 3.78007 21.6611L7.56014 14.9482H0C0 15.3854 0.109966 15.8226 0.329897 16.2175L1.81443 18.8547Z",
        fill: "#0066DA"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12 7.05169L8.21993 0.338867C7.8488 0.564508 7.53265 0.874765 7.31271 1.26964L0.329897 13.6799C0.11401 14.0663 0.00028744 14.5038 0 14.9491H7.56014L12 7.05169Z",
        fill: "#00AC47"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.2806 21.6611C20.6518 21.4354 20.9679 21.1252 21.1878 20.7303L21.6277 19.9547L23.7308 16.2175C23.9507 15.8226 24.0607 15.3854 24.0607 14.9482H16.5L18.1088 18.1918L20.2806 21.6611Z",
        fill: "#EA4335"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.0301 7.05128L15.8101 0.338462C15.439 0.112821 15.0129 0 14.573 0H9.48711C9.04725 0 8.62113 0.126923 8.25 0.338462L12.0301 7.05128Z",
        fill: "#00832D"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.4698 14.9482H7.59013L3.81006 21.6611C4.18119 21.8867 4.60731 21.9995 5.04717 21.9995H19.0128C19.4527 21.9995 19.8788 21.8726 20.2499 21.6611L16.4698 14.9482Z",
        fill: "#2684FC"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.2388 7.47477L16.7473 1.26964C16.5274 0.874765 16.2113 0.564508 15.8401 0.338867L12.0601 7.05169L16.4999 14.9491H24.0463C24.0463 14.5119 23.9363 14.0748 23.7164 13.6799L20.2388 7.47477Z",
        fill: "#FFBA00"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5038_1153",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "22",
          fill: "white"
        })
      })
    })]
  }));
};

GoogleDriveLogo.defaultProps = {
  width: "24",
  height: "22",
  viewBox: "0 0 24 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const GoogleDriveSyncBadge = _ref => {
  let {
    className,
    label = 'Syncing Google Drive'
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.badge, className),
    children: [/*#__PURE__*/_jsx(GoogleDriveLogo, {}), /*#__PURE__*/_jsx("span", {
      children: label
    })]
  });
};

export default GoogleDriveSyncBadge;